import { useEffect } from 'react';

type Handler = (event: TouchEvent) => void;
type Ref = React.MutableRefObject<any>;

export const useClickOutside = (
  ref: Ref,
  handler: Handler,
  ignoreModals?: boolean,
  selectorsToIgnore?: string[],
) => {
  useEffect(() => {
    const listener = (event: TouchEvent) => {
      // Check if click is outside the ref element
      if (!ref?.current?.contains(event.target)) {
        const target = event.target as HTMLElement;

        // If ignoreModals is enabled, check if click is inside a modal
        if (ignoreModals) {
          // Check if the click is inside a modal portal
          if (target.closest('.portal-modal')) {
            return; // Don't trigger handler - we're inside a modal
          }
        }

        // If the click outside needs to ignore certain selectors
        if (selectorsToIgnore) {
          for (const selector of selectorsToIgnore) {
            if (target.closest(selector)) {
              return;
            }
          }
        }

        handler(event);
      }
    };
    document.addEventListener('touchend', listener);
    return () => {
      document.removeEventListener('touchend', listener);
    };
  }, [ref, handler, ignoreModals, selectorsToIgnore]);
};
